import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
// import "./R66MemberInformationForm.scss";
import { Alert } from "@mui/material";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function NFIMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);
  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [phone, setPhone] = useState(props.currState.MemberLookup.phone);
  const [firstName, setFirstName] = useState(props.currState.FirstName);
  const [lastName, setLastName] = useState(props.currState.LastName);
  const [checkDuplicateName, setCheckDuplicateName] = useState(false);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [createContacts, setCreateContact] = useState(["Create a new contact", ""]);

  const [checkContact, setCheckContact] = useState([]);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    // devLog(props);
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, [contacts]);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
      // devLog("memberInfo: " + memberInfo);
    }
  };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    // devLog("selected Contact: ", sc);
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
    if (sc === undefined) {
      // devLog(
      // "selected undefined Contact: ",
      //   props.currState.FirstName + " " + props.currState.LastName
      // );
      setFirstName(firstName);
      setLastName(lastName);
    } else {
      setFirstName(sc.firstName);
      setLastName(sc.lastName);
      // devLog(
      //   "selected defined Contact: ",
      //   sc.firstName + " " + sc.lastName
      // );
    }
  };

  // const onSelectNewContact = (contactInfo) => {
  //   devLog("selected Contact: ", contactInfo);
  //   setSelectedContact(
  //     props.currState.FirstName + " " + props.currState.LastName
  //   );
  //   devLog("New Contact Name: ", selectedContact);
  //   onMemberInfo(memberInfo, contactInfo);
  // };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      // setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        memberNumber: memberNumber,
        searchType: searchType,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.contactInfo === "object") {
          if (!json.data.error) {
            setContacts(json.data.contactInfo);
            onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName) => {
    contacts.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
      ) {
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };

  return (
    <>
      <div className="formContainer">
        {/* {memberInfo ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerYear")}</b>:{" "}
                {memberInfo.year}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerMake")}</b>:{" "}
                {memberInfo.make}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerModel")}</b>:{" "}
                {memberInfo.model}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )} */}
        {memberInfo ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4 style={{ fontWeight: "bold" }}>{t("description.ContactInformationHeader")}</h4>
              <hr />
              <>
                {contacts.map((contact, index) => {
                  return (
                    <div
                      key={index}
                      value={contact}
                      className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(contact);
                      }}
                    >
                      <div className="contact-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedContact === contact ? "selected" : ""}
                        />
                        <div value={contact} className="vehicle-list-item-col-1">
                          <h5 value={contact} className="name-h5">
                            {contact.firstName} {contact.lastName}
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {!checkDuplicateName ? (
                  <>
                    <hr />
                    <h4 style={{ fontWeight: "bold" }}>{t("description.AddContactInformationHeader")}</h4>
                    <hr />
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedContact === undefined}
                        onClick={(e) => {
                          // setSelectedContact(undefined);
                          onSelect(undefined);
                        }}
                      />
                      <div className="vehicle-list-item-col-1">
                        <h5 className="name-h5">
                          {props.currState.FirstName} {props.currState.LastName}
                        </h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default NFIMemberInformationForm;
